import { OptionDescription } from './option.type';
import { EPaymentDueDate } from '../enums/day.enum';

export type PaymentDueDateRecord = Record<EPaymentDueDate, OptionDescription<EPaymentDueDate>>;
